<div class="modal-header">
  <h4 class="modal-title pull-left">
    @if (action === 'enable') {
      <span>
        {{ 'company.payment_remarks.payment_remarks_enable_title' | translate }}
      </span>
    }
    @if (action === 'disable') {
      <span>
        {{ 'company.payment_remarks.payment_remarks_disable_title' | translate }}
      </span>
    }
  </h4>
  <button type="button" class="close pull-right" aria-label="Close modal" (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <h6>
    @if (action === 'enable') {
      @if (watchlistUuid) {
        <span>
          {{ 'company.payment_remarks.payment_remarks_enable_question' | translate }}
        </span>
      }
      @if (companyUuid) {
        <span>
          {{ 'company.event_feed.options.payment_remarks.payment_remarks_enable_question' | translate }}
        </span>
      }
    }
    @if (action === 'disable') {
      @if (sensitiveDataWatchlistAccessUuid) {
        <span>
          {{ 'company.payment_remarks.payment_remarks_disable_question' | translate }}
        </span>
      }
      @if (sensitiveDataCompanyAccessUuid) {
        <span>
          {{ 'company.event_feed.options.payment_remarks.payment_remarks_disable_question' | translate }}
        </span>
      }
    }
  </h6>
</div>
@if (!isLoading()) {
  <div class="modal-footer">
    <button nkButton color="primary" [ghost]="true" (click)="cancel()">
      {{ 'common.cancel' | translate }}
    </button>
    <button class="btn btn-danger" (click)="confirm(action)">
      @if (action === 'enable') {
        <span>
          {{ 'company.payment_remarks.modals.enable_button' | translate }}
        </span>
      }
      @if (action === 'disable') {
        <span>
          {{ 'company.payment_remarks.modals.disable_button' | translate }}
        </span>
      }
    </button>
  </div>
} @else {
  <div class="modal-footer">
    <nk-spinner display="inline"></nk-spinner>
  </div>
}
